export class GetParties {
    public static readonly type = '[Party] Get parties';
}
